import ko from 'knockout';
import $ from 'jquery';
import FormatterCommon from './formatter-common';
import ChartFormatterCommon from './linechart-formatter-common';

    function QualityGraphsFormatter(params, observableOptions) {

        var self = this;

        self.observableOptions = observableOptions;

        self.options = observableOptions();

        self.formatterCommon = FormatterCommon;
        self.chartFormatterCommon = new ChartFormatterCommon();

        self.graphType = params.type;

        self.isEndpointQuality = self.options.isEndpoint;

        self.observableFormattedData = ko.observable({});

        self.subscriptions = [];
    }

    function GetCallQualityLineGraphData(source, columns, options, tooltipSuperTitle, formatterCommon, chartFormatterCommon) {

        if ($.isEmptyObject(source)) {
            return {
                pointDot: true,
                max: 10,
                replaceMode: false,
                xaxislabels: [],
                legend: [],
                legendColors: linechartcolorlist,
                lines: [],
                data: [], //series1-label1-val1, series1-label2-val2, series2-label1-val3, ...
                strokeColors: [RED, BLUE]
            };
        } else {

            var initlabels = chartFormatterCommon.GenerateTimeline(2);
            var lines = ["Transmit", "Receive"];
            var filteredlines = lines;
            var linechartdata = [];
            var max = initlabels.length;


            for (var i = 0; i < lines.length; i++) {
                linechartdata[i] = [];
                for (var j = 0; j < max; j++) {
                    linechartdata[i].push(null);
                }
            }

            if (options && options.filter) {
                filteredlines = chartFormatterCommon.getLines(lines, options);
            }

            var startindex = 0;

            if (source.length > max) {
                startindex = source.length - max;
            }

            for (var k = startindex; k < source.length; k++) {

                var newvalues = [];

                //if ($.inArray("Bridges", filteredlines) > -1) {
                for (var l = 0; l < columns.length; l++) {
                    var col = columns[l];
                    var str = source[k][col];
                    if (!str)
                        str = 0;
                    var value = str;

                    newvalues.push([parseFloat(value)]);
                }
                //}

                linechartdata = formatterCommon.shiftValues(linechartdata, newvalues);
            }

            return {
                pointDot: true,
                max: 10,
                replaceMode: true,
                xaxislabels: initlabels,
                lines: filteredlines,
                drawYAxisLine: false,
                legend: lines,
                legendColors: chartFormatterCommon.getLegendColors(lines, filteredlines),
                data: linechartdata,
                strokeColors: chartFormatterCommon.getLineColors(lines, filteredlines),
                //scaleMax: 100,
                pointHitDetectionRadius: 10,
                tooltipSuperTitle: tooltipSuperTitle,
                labelsFilter: function (labelval, index) {
                    return (index % 2) !== 0;
                }
            };
        }
    }

    function ComposeData(formatterCommon, chartFormatterCommon, sourcelist, options, graphType, initFlag) {

        var obj = sourcelist[options.callId];
        if (!obj || !obj[obj.length - 1])
            return null;

        var result;

        if (graphType == 'AudioPacketLoss')
        {
            result = GetCallQualityLineGraphData(obj, ['txAudioPacketlossPerc', 'rxAudioPacketlossPerc'], options, "Packet Loss - Audio", formatterCommon, chartFormatterCommon);
            if (result)
                result.ylabelSuffix = "%";

            return result;
        }

        else if (graphType == 'VideoPacketLoss')
        {
            result = GetCallQualityLineGraphData(obj, ['txVideoPacketlossPerc', 'rxVideoPacketlossPerc'], options, "Packet Loss - Video", formatterCommon, chartFormatterCommon);
            if (result)
                result.ylabelSuffix = "%";

            return result;
        }

        else if (graphType == 'PresentationPacketLoss') {
            result = GetCallQualityLineGraphData(obj, ['txPresPacketlossPerc', 'rxPresPacketlossPerc'], options, "Packet Loss - Presentation", formatterCommon, chartFormatterCommon);
            if (result)
                result.ylabelSuffix = "%";

            return result;
        }

        else if (graphType == 'AudioJitter') {
            return GetCallQualityLineGraphData(obj, ['txAudioJitter', 'rxAudioJitter'], options, "Jitter - Audio", formatterCommon, chartFormatterCommon);
        }
        else if (graphType == 'VideoJitter') {
            return GetCallQualityLineGraphData(obj, ['txVideoJitter', 'rxVideoJitter'], options, "Jitter - Video", formatterCommon, chartFormatterCommon);
        }
        else if (graphType == 'PresentationJitter') {
            return GetCallQualityLineGraphData(obj, ['txPresJitter', 'rxPresJitter'], options, "Jitter - Presentation", formatterCommon, chartFormatterCommon);
        }
    }


    QualityGraphsFormatter.prototype.RefreshData = function () {
        var self = this;

        self.observableFormattedData(ComposeData(self.formatterCommon, self.chartFormatterCommon, self.sourceList(), self.options, self.graphType));

    };

    QualityGraphsFormatter.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    QualityGraphsFormatter.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    QualityGraphsFormatter.prototype.initialize = function (dataRepository) {
        var self = this;

        self.dataRepository = dataRepository;

        if (self.isEndpointQuality) {
            self.sourceList = dataRepository.endpointCallData;
        } else {
            self.sourceList = dataRepository.systemDetailParticipantData;
        }

        self.subscriptions.push(self.sourceList.subscribe(function() { self.DataUpdated(); }));

        self.subscriptions.push(self.observableOptions.subscribe(function () { self.OptionsUpdated(); }));

        //initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
        if (!$.isEmptyObject(self.sourceList()))
            self.RefreshData();
    };


    QualityGraphsFormatter.prototype.getObservableData = function () {
        var self = this;

        return self.observableFormattedData;
    };

    QualityGraphsFormatter.prototype.dispose = function() {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default QualityGraphsFormatter;
